// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

interface BonusCodeProps {
    buttonText?: string;
    config: {
        blocked: boolean;
        message: string;
        link: string;
    };
}

const BlockedContentModal: FunctionalComponent<BonusCodeProps> = ({ buttonText, config }) => {
    return (
        <div class="page-blocker__overlay">
            <div class="page-blocker__container">
                <div class="page-blocker__message">{config.message}</div>
                <a class="page-blocker__button" href={config.link}>
                    {buttonText || 'Take Me There'}
                </a>
            </div>
        </div>
    );
};

export default BlockedContentModal;
